.downloadButton {
    display: inline-block;
    padding: 7px 20px;
    font-weight: normal;
    color: #ffffff;
    text-decoration: none;
    white-space: nowrap;
    background: chocolate;
    border: solid 1px #cccccc;
    border-radius: 5px;
    box-shadow: 2px 2px #bbbbbb;
}

.downloadButton:hover {
    color: #ffffff;
    text-decoration: none;
    background: orangered;
    border: solid 1px #888888;
}

.downloadButton:active {
    transform: translate(2px, 2px);
    box-shadow: none;
}
